<div class="report-cardlist">
  <div class="user-list" (click)="onClick()">
    <div class="initials-container" [ngStyle]="{ 'background-color': color }">
      <span>{{ (user?.firstName || '-')[0] | uppercase }}{{ (user?.lastName || '-')[0] | uppercase }}</span>
    </div>
    <div class="userInfo">
      <div class="username">{{ user?.firstName || '-' }} {{ user?.lastName || '-' }}</div>
      <div class="email">{{ user?.emailAddress || '-' }}</div>
      <div class="status" *ngIf="isActiveUser != null">
        <span
          >{{ 'recordsSearch.status' | xTranslate }}:
          {{ (isActiveUser ? 'recordsSearch.active' : 'recordsSearch.inactive') | xTranslate }}
        </span>
      </div>
    </div>
    <div class="assign-bgcolor" [ngClass]="{ 'miq-only': isOnMIQ }">
      <div class="assignCheck">
        <div>
          <mat-checkbox [checked]="selected"></mat-checkbox>
        </div>
        <div *ngIf="isOnMIQ != null" class="contactcard-icon">
          <label *ngIf="isOnMIQ" class="miq-icon" l10nTranslate>shared.miq</label>
          <mat-icon *ngIf="!isOnMIQ">cloud_queue</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
